'use client'

import './IconButton.css'

type IconButtonProps = {
  children: React.ReactNode
  onClick?: () => void
  /** Accessible label, required since the button is icon-only. */
  ariaLabel: string
  title?: string
  disabled?: boolean
  className?: string
  type?: 'button' | 'submit' | 'reset'
  /** Override when more than one IconButton renders on the same page. */
  id?: string
}

/** Small icon-only button for inline actions like dismiss/close. */
export default function IconButton({
  children,
  onClick,
  ariaLabel,
  title,
  disabled = false,
  className,
  type = 'button',
  id = 'icon-button',
}: IconButtonProps) {
  return (
    <button
      id={id}
      type={type}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      title={title}
      className={`icon-button${className ? ` ${className}` : ''}`}
    >
      {children}
    </button>
  )
}
